import type { NewsletterData } from './newsletterData'
import { newslettersOrderedByPopularity } from './newsletterData'

export function getMostPopularUnsubscribedNewsletters(
  subscribedNewslettersCodes: string[],
  limit: number
): NewsletterData[] {
  const results: NewsletterData[] = []
  for (let i = 0; i < newslettersOrderedByPopularity.length && results.length < limit; i++) {
    const { code } = newslettersOrderedByPopularity[i]

    if (!subscribedNewslettersCodes.includes(code)) {
      results.push(newslettersOrderedByPopularity[i])
    }
  }
  return results
}
